import { Typography } from '@mui/material';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import EnhancedTable from 'lib/designSystem/Table';
import React from 'react';

import { PayOutDocument } from '../../../../types';

const headers: { key: string; label: string; type?: any }[] = [
  { key: 'folio', label: 'Folio' },
  { key: 'businessName', label: 'Cliente' },
  // { key: 'stakeholderName', label: 'Deudor' },
  { key: 'issuedDate', label: 'Fecha de emisión', type: 'date' },
  { key: 'amount', label: 'Monto documento', type: 'money' },
];

interface PayOutDetailDocumentsProps {
  documents: PayOutDocument[];
}

const PayOutDetailDocuments = (props: PayOutDetailDocumentsProps) => {
  const { documents } = props;

  return (
    <div>
      <HeaderWithActions
        title="Acá puedes ver los pagos realizados."
        variant="body1"
      />
      {documents.length === 0 ? (
        <Typography variant="body1">
          No hay documentos aplicados en este pago
        </Typography>
      ) : (
        <EnhancedTable dataHeaders={headers} data={documents} />
      )}
    </div>
  );
};

export default PayOutDetailDocuments;
